import { render, staticRenderFns } from "./AddBookingModal.vue?vue&type=template&id=2882a264"
import script from "./AddBookingModal.vue?vue&type=script&lang=js"
export * from "./AddBookingModal.vue?vue&type=script&lang=js"
import style0 from "./AddBookingModal.vue?vue&type=style&index=0&id=2882a264&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports